var defaultWgt;
var newsletterWgt;
var forCompaniesWgt;
var forCompaniesAltWgt;

window.onCaptchaSuccess = window.onCaptchaSuccess || function(token){};
window.onCaptchaExpired = window.onCaptchaExpired || function(){};

window.onCompaniesCaptchaSuccess = window.onCompaniesCaptchaSuccess || function(token){};
window.onCompaniesCaptchaExpired = window.onCompaniesCaptchaExpired || function(){};

window.onCompaniesAltCaptchaSuccess = window.onCompaniesAltCaptchaSuccess || function(token){};
window.onCompaniesAltCaptchaExpired = window.onCompaniesAltCaptchaExpired || function(){};

//recaptcha initiation
function generateCaptcha() {
   defaultWgt = grecaptcha.render('captcha', {
    'sitekey' : '6LdjOr4pAAAAABJ4mvluTDdPINTOilVyS0ILHdOB',
        'callback': onCaptchaSuccess,
    'expired-callback': onCaptchaExpired
  });
}

//recaptcha validation
function verifyCaptcha() {
  let doSubmit = false;
  let captchaResp = grecaptcha.getResponse(defaultWgt);

  if(captchaResp && captchaResp != "") {
      doSubmit = true;
  }

  return doSubmit;
}

//initiation recaptcha for newsletter form
function generateNewsletterCaptcha() {
  newsletterWgt = grecaptcha.render('newsletter_captcha', {
    'sitekey' : '6LdjOr4pAAAAABJ4mvluTDdPINTOilVyS0ILHdOB'
  });
}

//recaptcha validation for newsletter form
function verifyNewsletterCaptcha() {
  let doSubmit = false;
  let captchaResp = grecaptcha.getResponse(newsletterWgt);

  if(captchaResp && captchaResp != "") {
      doSubmit = true;
  }

  return doSubmit;
}

//initiation recaptcha for new form in for companies page
function generateForCompaniesCaptcha() {
  forCompaniesWgt = grecaptcha.render('for_companies_captcha', {
    'sitekey' : '6LdjOr4pAAAAABJ4mvluTDdPINTOilVyS0ILHdOB',
     'callback': onCompaniesCaptchaSuccess,
    'expired-callback': onCompaniesCaptchaExpired
  });
}

//recaptcha validation for companies page
function verifyForCompaniesCaptcha() {
  let doSubmit = false;
  let captchaResp = grecaptcha.getResponse(forCompaniesWgt);

  if(captchaResp && captchaResp != "") {
      doSubmit = true;
  }

  return doSubmit;
}

//initiation recaptcha for new alternate form in for companies page
function generateForCompaniesAltCaptcha() {
  forCompaniesAltWgt = grecaptcha.render('for_companies_captcha_alternate', {
    'sitekey' : '6LdjOr4pAAAAABJ4mvluTDdPINTOilVyS0ILHdOB',
    'callback': onCompaniesAltCaptchaSuccess,
    'expired-callback': onCompaniesAltCaptchaExpired
  });
}

//recaptcha validation for alternate form in companies page
function verifyForCompaniesAltCaptcha() {
  let doSubmit = false;
  let captchaResp = grecaptcha.getResponse(forCompaniesAltWgt);

  if(captchaResp && captchaResp != "") {
      doSubmit = true;
  }

  return doSubmit;
}

//set no capture attribute to all form fields
function setNoCapture(formId, className) {
  $('#'+formId+' .'+className).each(function() {
      $(this).attr('data-cr-no-capture', 'data-cr-no-capture');
  });
}

 function submitForm(formId, className, pageName) {
   //$(document).find('#'+ formId +' .g-recaptcha-response').remove();
   $('#'+ formId +' .g-recaptcha-response').remove();

   $('#'+formId).removeAttr('data-cr-no-capture');
   $('#'+formId+' .'+className).each(function() {
      $(this).removeAttr('data-cr-no-capture');
   });

   let form = document.querySelector('#'+formId);
     console.log('Submitting form', formId, pageName);
   CallTrk.captureForm(form, function(response) {
     console.log('calltrk response', response, form);
     //Reset UI
     $('#'+formId)[0].reset();     
   });   //submit data to callrail
  
   $('.'+pageName+'-form-block').hide();
   $('.'+pageName+'-thankyou-block').show();
 }

function submitSalesForm(formId, className, pageName) {
  let form = document.querySelector('#' + formId);
 
  // Allow CallRail to capture all real inputs
  $('#' + formId).removeAttr('data-cr-no-capture');
  $('#' + formId + ' .' + className).removeAttr('data-cr-no-capture');
 
  // Exclude reCAPTCHA safely
  let captchaField = form.querySelector('.g-recaptcha-response');
  if (captchaField) {
    captchaField.setAttribute('data-cr-no-capture', 'true');
  }
 
  CallTrk.captureForm(form, function(response) {
    console.log('CallRail response', response);
 
    // UI changes AFTER capture
    form.reset();
    $('.' + pageName + '-form-block').hide();
    $('.' + pageName + '-thankyou-block').show();
  });
}